// extracted by mini-css-extract-plugin
module.exports = {"editor":"RichTextEditor_editor__1Q4pl"};